import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import {
  updateGeneralConfigurationData,
} from '../../../../../store/slices/createCRSlice';
import {
  selectGeneralConfigurationData,
} from '../../../../../store/selectors/createCRSelectors';
import {
  selectConduitSizes,
  selectConduitTypes,
  selectMountSystems,
} from '../../../../../store/selectors/databaseSelectors';
import { GeneralConfigurationSelector } from './GeneralConfigurationSelector';
import { StructuralMultipleSelector } from './StructuralMultipleSelector';

interface MountingStepProps {
  isEnabled: boolean;
}

export const MountingStep: React.FC<MountingStepProps> = ({ isEnabled }) => {
  const dispatch = useAppDispatch();
  const generalConfigurationData = useAppSelector(selectGeneralConfigurationData);
  const { is_initialized } = useAppSelector((state) => state.database);

  // Database selectors
  const mountSystems = useAppSelector(selectMountSystems);
  const conduitSizes = useAppSelector(selectConduitSizes);
  const conduitTypes = useAppSelector(selectConduitTypes);

  return (
    <div className="flex-1 overflow-y-auto px-2 py-4 min-h-0">
      <div className="grid grid-cols-1 gap-6">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200/80 border-l-[3px] border-l-rose-400 overflow-hidden">
            <div className="px-5 py-3 3xl:px-6 3xl:py-3.5 bg-rose-100/50 border-b border-slate-200/60">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h16M4 12h16M4 17h16" />
                </svg>
                <span className="text-[11px] 3xl:text-xs uppercase tracking-widest font-bold text-slate-700">General Configuration</span>
              </div>
              <p className="text-[10px] 3xl:text-xs text-slate-400 mt-0.5 ml-6">Mount system, conduit, and trenching</p>
            </div>
            <div className="p-5">
            <GeneralConfigurationSelector
              isEnabled={isEnabled}
              selectedMountSystem={generalConfigurationData.mount_system}
              selectedRoofConduitSize={generalConfigurationData.roof_mount_conduit_size}
              selectedRoofConduitType={generalConfigurationData.roof_mount_conduit_type}
              selectedBosConduit={generalConfigurationData.bos_conduit}
              selectedTrenchConduitSize={generalConfigurationData.trench?.conduit_size}
              selectedTrenchConduitType={generalConfigurationData.trench?.conduit_type}
              trenchLength={generalConfigurationData.trench?.length}
              trenchDepth={generalConfigurationData.trench?.depth}
              onMountSystemSelect={(system) => dispatch(updateGeneralConfigurationData({ mount_system: system }))}
              onRoofConduitSizeSelect={(size) => dispatch(updateGeneralConfigurationData({ roof_mount_conduit_size: size }))}
              onRoofConduitTypeSelect={(type) => dispatch(updateGeneralConfigurationData({ roof_mount_conduit_type: type }))}
              onBosConduitChange={(value) => dispatch(updateGeneralConfigurationData({ bos_conduit: value }))}
              onTrenchConduitSizeSelect={(size) => dispatch(updateGeneralConfigurationData({ trench: { ...generalConfigurationData.trench, conduit_size: size } }))}
              onTrenchConduitTypeSelect={(type) => dispatch(updateGeneralConfigurationData({ trench: { ...generalConfigurationData.trench, conduit_type: type } }))}
              onTrenchLengthChange={(length) => dispatch(updateGeneralConfigurationData({ trench: { ...generalConfigurationData.trench, length } }))}
              onTrenchDepthChange={(depth) => dispatch(updateGeneralConfigurationData({ trench: { ...generalConfigurationData.trench, depth } }))}
              mountSystems={mountSystems}
              conduitTypes={conduitTypes}
              conduitSizes={conduitSizes}
              isLoading={!is_initialized}
              error={undefined}
            />
            </div>
        </div>

        <StructuralMultipleSelector isEnabled={isEnabled} />
      </div>
    </div>
  );
};
